module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-36.c3ca03df.png";